import {Component} from '@angular/core';

@Component({
    selector: 'app-sidebar-header',
    standalone: true,
    templateUrl: './app-sidebar-header.component.html'
})
export class AppSidebarHeaderComponent {
}
